var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg15Min(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3526 2.27255C18.3526 1.01745 19.3701 0 20.6252 0C21.8803 0 22.8977 1.01745 22.8977 2.27254V2.9504C32.0947 4.07109 39.2188 11.9068 39.2188 21.4065C39.2188 31.6754 30.8942 40 20.6253 40C10.3564 40 2.03174 31.6754 2.03174 21.4065C2.03174 17.0581 3.52443 13.0583 6.02535 9.89169L5.69211 9.58259C4.77192 8.72906 4.71788 7.29118 5.57141 6.37099C6.42494 5.4508 7.86282 5.39676 8.783 6.25029L9.25822 6.69108C11.8363 4.69669 14.9528 3.36475 18.3526 2.95043V2.27255Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6248 4.87889C22.7952 4.87889 24.9444 5.30639 26.9496 6.13697C28.9548 6.96756 30.7768 8.18498 32.3115 9.71971C33.8463 11.2544 35.0637 13.0764 35.8943 15.0816C36.7249 17.0869 37.1524 19.236 37.1524 21.4065L20.6248 21.4065L20.6248 4.87889Z",
    fill: "#C93F37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6263 22.4393C24.1676 24.2214 22.5499 25.5382 20.6246 25.5382C18.3426 25.5382 16.4927 23.6883 16.4927 21.4063C16.4927 19.1243 18.3426 17.2744 20.6246 17.2744C22.5499 17.2744 24.1676 18.5912 24.6263 20.3733L33.5126 20.3733C34.083 20.3733 34.5455 20.8358 34.5455 21.4063C34.5455 21.9768 34.083 22.4393 33.5126 22.4393L24.6263 22.4393Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6256,
    cy: 21.4063,
    r: 1.56258,
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15Min);
export default __webpack_public_path__ + "static/media/15min.09c8d46eae2fa127077f94a6fa6e9678.svg";
export { ForwardRef as ReactComponent };